<template>
  <transition name="indicator">
    <div class="indicator" v-show="visible">
      <div
        class="indicator-wrapper"
        :style="{ padding: text ? '20px' : '15px' }"
      >
        <dok-spin :size="spinSize" :type="spinnerType" class="indicator-spin" />
        <span class="indicator-text" v-show="text">{{ text }}</span>
      </div>
      <div class="indicator-mask" @touchmove.stop.prevent></div>
    </div>
  </transition>
</template>

<script type="text/babel">
import DokSpin from "../DokSpin"

export default {
  props: {
    text: String,
    spinnerType: {
      type: String,
      default: "snake"
    }
  },
  components: { DokSpin },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    spinSize() {
      if (this.spinnerType === "fading-circle") {
        return 40
      }
      return 32
    }
  }
}
</script>

<style lang="scss" scope>
.indicator {
  transition: opacity 0.2s linear;
  &-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    box-sizing: border-box;
    text-align: center;
    z-index: 3000;
  }
  &-text {
    display: block;
    color: #fff;
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
  }
  &-spin {
    display: inline-block;
    text-align: center;
  }
  &-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: transparent;
    z-index: 3000;
  }
}
.indicator-enter,
.indicator-leave-active {
  opacity: 0;
}
</style>
